import Api from '../Api'

export async function addTrigger(values: any) {
  const response = await Api.post('/add_trigger', values)
  return response.data
}
